import { render } from "./StudyCard.vue?vue&type=template&id=5677e700&scoped=true&ts=true"
import script from "./StudyCard.ts?vue&type=script&lang=ts&external"
export * from "./StudyCard.ts?vue&type=script&lang=ts&external"

import "./StudyCard.scss?vue&type=style&index=0&id=5677e700&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5677e700"]])

export default __exports__